import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React from 'react';
import HeaderButtonsMobile from './HeaderButtonsMobile';
import HeaderLogo from './HeaderLogo';

const HeaderBurgerMenu = dynamic(() => import('../header/HeaderBurgerMenu'), {
  ssr: true,
});
const HeaderTopMobile = ({ bt, navigation, path }) => {
  return (
    <>
      <div className="row top-block align-items-center">
        <div className="d-md-none col">
          <HeaderBurgerMenu
            isFindPage
            isLoggedIn={false}
            navigation={navigation}
            path={path}
          />
        </div>
        <div className="d-flex col-4 col-md-auto align-items-center justify-content-center text-center">
          <HeaderLogo isMobile />
        </div>
        <div className="d-flex justify-content-end col col-md-auto order-md-12">
          <HeaderButtonsMobile bt={bt} />
        </div>
      </div>
    </>
  );
};

HeaderTopMobile.propTypes = {
  bt: PropTypes.string,
  navigation: PropTypes.array,
  path: PropTypes.string,
};

export default HeaderTopMobile;
